import { combineReducers } from 'redux';

import unclosedDates from './uncloseddatesreport/reducer';

export default combineReducers({
  unclosedDates,
});



// WEBPACK FOOTER //
// ./src/pages/uncloseddates/state/reducer.js